
export default {
  name: 'PlusIcon',
  props: {
    ariaHidden: {
      type: Boolean,
      default: true,
    },
    ariaLabel: {
      type: String,
      default: '',
    },
    role: {
      type: String,
      default: 'img',
    },
  },
}
